<template>
  <v-container fill-height fluid>
    <v-row>
      <v-col
        align="center"
        justify="center">
          <v-img
            width="160px"
            src="https://pjili-public.s3.ca-central-1.amazonaws.com/global/images/pjili-logo-sm.png"
          ></v-img>
      </v-col>
    </v-row>
    <v-row
      align="center"
      justify="center">
      <v-col>
        <h1 class="text-center mb-5">Welcome to Pjili!</h1>

        <v-card
          class="mx-auto"
          max-width="400"
          outlined
        >
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-subtitle class="text-center">Just few details and you're done.</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>
            <v-alert
              v-if="hasErrors()"
              color="warning">
              <ul>
                <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
              </ul>
            </v-alert>
            <v-form>
              <v-text-field
                v-model.trim="Payload.Email"
                name="Email"
                label="Email"
              />
              <v-text-field
                v-model="Payload.First"
                name="First"
                label="First name" />
              <v-text-field
                v-model="Payload.Last"
                name="Last"
                label="Last name" />
              <v-text-field
                v-model="Payload.Password"
                :type="showPassword ? 'text' : 'password'"
                name="Password"
                label="Password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" 
                @click:append="showPassword = !showPassword"
              />
              <v-text-field
                v-model="PasswordConfirm"
                :type="showConfirmPassword ? 'text' : 'password'"
                name="PasswordConfirm"
                label="Confirm new password"
                :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'" 
                @click:append="showConfirmPassword = !showConfirmPassword"
              />
            </v-form>

            <PasswordValidator v-on:passwordValidation="receiveValidation($event)" :Password="Payload.Password" :PasswordConfirm="PasswordConfirm" />

          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click.prevent="signUp()"
              rounded
              :loading="loading"
              color="info"
              :disabled="!passwordValid"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PasswordValidator from "@/components/PasswordValidator.vue";
import { mapGetters } from 'vuex'

export default {
  name: "SignupFinish",
  data() {
    return {
      Payload: {
        Email: '',
        First: '',
        Last: '',
        Password: '',
        Intent: '',
      },
      validPassword: false,
      PasswordConfirm: '',
      showPassword: false,
      showConfirmPassword: false,
      passwordValid: false,
      loading: false,
      errors: []
    };
  },
  components: {
    PasswordValidator
  },
  computed: {
    signUpIntent() {
      return this.$store.state.signupintent.signUpIntent
    },
    ...mapGetters([
      'continueHref',
    ])
  },
  created() {
    if (this.signUpIntent === null) {
      this.$router.push({ name: 'signup-start' })
    } else {
      this.Payload.Intent = this.signUpIntent.Id
      if(this.continueHref) {
        this.Payload.Continue = this.continueHref
      }
    }
  },
  methods: {
    receiveValidation(pswValidation){
      if (pswValidation.valid){
        this.passwordValid = true
      } else {
        this.passwordValid = false
      }
    },
    signUp() {
      this.loading = true

      this.$axios.post('users', this.Payload)
        .then(() => {
          this.loading = false
          this.errors = []
          this.$store.dispatch('SetSignUpIntent', null)
          this.$store.dispatch("addNotification", {
            type: 'success',
            message: 'We have sent an email with a confirmation link to your email address. In order to complete the sign-up process, please click the confirmation link.'
          });
          this.$router.push({ name: 'login' })
        })
        .catch((error) => {
          this.loading = false
          if (!error.response) {
            this.errors = ['Network Error']
          } else if (error.response.status) {
            this.errors = error.response.data.errors
          } else {
            this.errors = ['Unknown Error']
          }
        })
    },
    hasErrors() {
      return this.errors.length > 0
    },
  }
}
</script>